// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './plugins/element.js'
import ElementUi from 'element-ui'
// import VueAMap from 'vue-amap';
import  {formatDate} from './utils/date'
import 'lib-flexible/flexible'
import VCharts from 'v-charts'
var qs=require('qs');
import axios from './utils/axios.js'
Vue.filter('date',(date)=>{
  date = new  Date(date)
  return formatDate(date,'yyyy-MM-dd hh:mm:ss')
})
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)
import 'element-ui/lib/theme-chalk/index.css'
import {loadURL} from './config'
import {pathURL} from './config'
import'quill/dist/quill.snow.css'
import'quill/dist/quill.bubble.css'
import VDistpicker from 'v-distpicker'
Vue.component('v-distpicker', VDistpicker)
import show from './components/show.vue'
Vue.component('show', show)
import footer from './components/footer.vue'
Vue.component('footer1', footer)
import * as voicePromptFun from './utils/voicePrompt' 
Vue.prototype.voicePrompt = voicePromptFun.voicePrompt
import'quill/dist/quill.core.css'
import VueQuillEditor from 'vue-quill-editor/dist/ssr'
Vue.use(VCharts)
Vue.use(VueQuillEditor)
Vue.use(ElementUi)
// Vue.use(VueAMap);
Vue.config.productionTip = false
Vue.prototype.loadURL=loadURL
Vue.prototype.$date=formatDate
Vue.prototype.pathURL=pathURL
Vue.prototype.$axios=axios
Vue.prototype.$qs=qs
import Oss from './utils/alioss'
    Vue.use(Oss)
/* eslint-disable no-new */
// VueAMap.initAMapApiLoader({
//   key: '59006a45415324d6e6194101e2764719',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
//   // 默认高德 sdk 版本为 1.4.4
//   v: '1.4.4'
// });
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js